import { apiFetch } from './api';

/** Ouvre une session : `identifiant` accepte l'identifiant ou l'email. */
export function connexion(identifiant, motDePasse) {
  return apiFetch('/auth/connexion', {
    method: 'POST',
    body: JSON.stringify({ identifiant, motDePasse }),
  });
}

export function deconnexion() {
  return apiFetch('/auth/deconnexion', { method: 'POST' });
}

/** Compte connecté — rejette avec status 401 quand aucune session n'est ouverte. */
export function getMoi() {
  return apiFetch('/auth/moi');
}

export function changerMotDePasse(actuel, nouveau) {
  return apiFetch('/auth/mot-de-passe', {
    method: 'PUT',
    body: JSON.stringify({ actuel, nouveau }),
  });
}

/**
 * Le compte connecté modifie son accès (formateurs : paramètres d'accès de
 * leur fiche). Le mot de passe actuel est exigé ; `nouveau` est facultatif.
 */
export function modifierMonAcces({ identifiant, actuel, nouveau }) {
  return apiFetch('/auth/mon-acces', {
    method: 'PUT',
    body: JSON.stringify({ identifiant, actuel, nouveau }),
  });
}

/* ---------- Paramétrage > Accès ---------- */

export function getUtilisateurs() {
  return apiFetch('/utilisateurs');
}

export function createUtilisateur(data) {
  return apiFetch('/utilisateurs', { method: 'POST', body: JSON.stringify(data) });
}

/** `motDePasse` absent ou vide : inchangé. */
export function updateUtilisateur(id, data) {
  return apiFetch(`/utilisateurs/${id}`, { method: 'PUT', body: JSON.stringify(data) });
}

export function deleteUtilisateur(id) {
  return apiFetch(`/utilisateurs/${id}`, { method: 'DELETE' });
}
